import Axios from "axios";
import AppConfig from '@/config/AppConfig';
import { globalData } from "@/main";

export default {
  GetInvoice(claveAcceso) { 
    
    return Axios.get(
       AppConfig.aimAsurApiDigitalEasyUrl + "DigitalEasy/ObtenerFactura/" + claveAcceso
    );
  },
  cotizadores(profile, agencyId) { 
    const params = {
      userId: profile.user_id,
      agencyId: agencyId,
    }
    return Axios.get(
      "/quoting/cotizadores", {
        params: params
      }
    );
  },
  GetAllDataFactura(numeroLiquidacion, tipo) { 
    
    return Axios.get(
       AppConfig.aimAsurApiPeopleSoftUrl + "PeopleSoft/ObtenerFacturacion/" + numeroLiquidacion + "/Tipo/" + tipo
    );
  },
  valoresCalculados(numeroLiquidacion) {
    return Axios.get("/commission/valoresCalculados", {
      params: { numeroLiquidacion }
    });
  },

  ValidacionMenu() { 
    
    return Axios.get(
       AppConfig.aimAsurApiPeopleSoftUrl + "PeopleSoft/Validacion/aps/" 
    );
  },

  external(profile, agencyId) { 
    if(profile)
    {
      const params = {
        userId: profile.user_id,
        agencyId: agencyId,
      }
      return Axios.get(
        "/quoting/external", {
          params: params
        }
      );
    }
    else{
      localStorage.clear()
      this.store.dispatch("logoutUser");
      this.router.push('/session/login')
      location.reload();
    }

  },

  ValidacionCategoriaMenu(aps) { 
    
    return Axios.get(
       AppConfig.aimAsurApiPeopleSoftUrl + "PeopleSoft/Validacion/aps/Categoria/"+aps 
    );
  },

  ingresoFactura(model) {

        if (!globalData.validaSucursal) {
            model.Agencia = "0";

        } 
        
		let url =  AppConfig.aimAsurApiPeopleSoftUrl + "PeopleSoft/IngresoPago" ;
		return Axios.post(url, model)
	},


};